import React from 'react';
import { Skeleton, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles((theme) => ({
  div: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(-1)
  },
  text: {
    color: theme.palette.insights.classificatonLabel,
    ...theme.typography.body2,
    fontSize: theme.spacing(1.5),
    width: '5%'
  },
  container: {
    height: theme.spacing(10),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minWidth: '50%'
  },
  paper: {
    width: theme.spacing(0.2),
    height: theme.spacing(1.8)
  },
  innerDiv: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '85%'
  },
  skeleton: {
    backgroundColor: theme.skelton.color,
    width: '12%',
    height: theme.spacing(3.5)
  },
  skeletonNotes: {
    backgroundColor: theme.skelton.color,
    width: '80%',
    height: theme.spacing(3.5)
  }
}));

export const ClassificationBarSkelton: React.FC = () => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div
        className={classes.div}
        data-testid={'note-by-classification-skeleton'}
      >
        <div className={classes.innerDiv}>
          <Typography className={classes.text}>
            <FormattedMessage
              id={'insights.timeClassificationChart.UNCLASSIFIED'}
            />
          </Typography>
          <Skeleton className={classes.skeletonNotes} />
        </div>

        <Skeleton className={classes.skeleton} />
      </div>
      <div className={classes.div}>
        <div className={classes.innerDiv}>
          <Typography className={classes.text}>
            <FormattedMessage id={'insights.timeClassificationChart.PRIVATE'} />
          </Typography>
          <Skeleton className={classes.skeletonNotes} />
        </div>

        <Skeleton className={classes.skeleton} />
      </div>
      <div className={classes.div}>
        <div className={classes.innerDiv}>
          <Typography className={classes.text}>
            <FormattedMessage
              id={'insights.timeClassificationChart.ACCEPTED'}
            />
          </Typography>
          <Skeleton className={classes.skeletonNotes} />
        </div>

        <Skeleton className={classes.skeleton} />
      </div>
    </div>
  );
};
